<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <!-- ================= HEADER ================= -->
          <div class="page-header">
            <div class="d-flex justify-space-between align-start">

              <!-- Company Info -->
              <div class="company-info">
                <h4 class="company-name">
                  {{ order.branch?.company?.name || '' }}
                </h4>
                <p class="company-text">
                  {{ order.branch?.company?.address || '' }}
                </p>
                <p class="company-text">
                  <v-icon size="small">mdi-phone-outline</v-icon>
                  {{ order.branch?.company?.mobile || '' }}
                </p>
                <p class="company-text">
                  <v-icon size="small">mdi-email-outline</v-icon>
                  {{ order.branch?.company?.email || '' }}
                </p>
              </div>

              <!-- Logo -->
              <div>
                <v-img
                  :src="`${getFileServerUrl}/${order.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                  max-width="150"
                  max-height="70"
                  contain
                />
              </div>

            </div>

            <div class="text-center my-6">
              <h2 class="report-title">INVOICE BILL</h2>
            </div>
          </div>

          <!-- ================= BILL TO / SHIP TO ================= -->
          <div class=" mt-4" style="display:flex; justify-content:space-between; align-items:center;">
            <div class="info-box">
              <strong>Bill To</strong>
              <p>{{ order.bill_to }}</p>
            </div>

            <div class="info-box">
              <strong>Ship To</strong>
              <p>{{ order.ship_to }}</p>
            </div>
          </div>

          <!-- ================= META INFO ================= -->
          <div class="meta-box  mt-4">
            <div><strong>Invoice Code :</strong> {{ order.code }}</div>
            <div><strong>Invoice No :</strong> {{ order.invoice_no }}</div>
            <div><strong>Invoice Date :</strong> {{ formatDate(order.invoice_date) }}</div>
            <div><strong>Due Date :</strong> {{ formatDate(order.invoice_due_date) }}</div>
            <div><strong>Status :</strong> {{ order.status ? 'Active' : 'Inactive' }}</div>
          </div>

          <!-- ================= DETAILS TABLE ================= -->
          <table class="dep-table order-table mt-4">
            <thead>
              <tr>
                <th>SL</th>
                <th>Description</th>
                <th class="text-right">Price</th>
                <th class="text-right">Qty</th>
                <th class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in order.details" :key="row.id">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ row.item_description }}</td>
                <td class="text-right">{{ row.price }}</td>
                <td class="text-right">{{ row.quantity }}</td>
                <td class="text-right">{{ row.total }}</td>
              </tr>
            </tbody>
          </table>

          <!-- ================= TOTAL SECTION ================= -->
          <div class="total-box mt-4 " style="display:flex; justify-content:end;">
            <div>
              <!-- <div><strong>Total :</strong> {{ order.total }}</div>
              <div><strong>Paid :</strong> {{ order.paid }}</div> -->
              <div><strong>Total Due :</strong> {{ order.due }}</div>
            </div>
          </div>

          <!-- ================= BANK INFO ================= -->
          <div class="bank-box mt-4">
            <h4>Bank Information</h4>
            <p><strong>Bank Name :</strong> {{ order.bank_name }}</p>
            <p><strong>Account Name :</strong> {{ order.bank_ac_name }}</p>
            <p><strong>Account No :</strong> {{ order.bank_ac_no }}</p>
            <p><strong>Routing No :</strong> {{ order.routing_no }}</p>
            <p><strong>Swift Code :</strong> {{ order.swift_code }}</p>
          </div>

          <!-- ================= REMARKS ================= -->
          <div v-if="order.remarks" class="mt-4">
            <strong>Remarks :</strong>
            <p>{{ order.remarks }}</p>
          </div>


           <!-- ================= FOOTER ================= -->
          <v-row class="footer mt-4" style="border-top:1px solid #000; padding-top:12px;">
            <v-col cols="4" class="text-center">
              <div class="footer-item" style="display:flex;">
                <div style="display:flex; justify-content:center; align-items:center; font-size:25px;">
                  <v-icon small>mdi-whatsapp</v-icon>
                </div>
                <div> +8801798055022</div>
              </div>
            </v-col>

            <v-col cols="4" class="text-center">
              <div class="footer-item" style="display:flex;">
                <div style="display:flex; justify-content:center; align-items:center; font-size:25px;">
                  <v-icon small>mdi-web</v-icon>
                </div>
                <div>
                    info@anooshasourcing.com<br/>
                    www.anooshasourcing.com
                </div>
              </div>
            </v-col>

            <v-col cols="4" class="text-center">
              <div class="footer-item" style="display:flex;">
                <div style="display:flex; justify-content:center; align-items:center; font-size:25px;">
                  <v-icon small>mdi-home</v-icon>
                </div>
                <div>
                    5th Floor, House 417, Road 7<br/>
                    Baridhara DOHS, Dhaka-1206
                </div>
              </div>
            </v-col>
          </v-row>


        </v-sheet>
      </v-col>
    </v-row>

    <!-- ================= PRINT BUTTON ================= -->
    <v-row justify="center" class="d-print-none mt-4">
      <v-btn color="primary" prepend-icon="mdi-printer" @click="print">
        Print
      </v-btn>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();

const order = ref({
  branch: {},
  details: []
});

const getFileServerUrl = computed(
  () => store.getters.getFileServerUrl
);

// date format helper
function formatDate(date) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-GB");
}

// fetch invoice bill
async function fetchDetails(id) {
  const res = await store.dispatch("getInvoiceBillById", { id });
  order.value = res.data.data;
}

// print function
  function print() {
      const printContent = document.getElementById("printable-area").innerHTML;
      const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

      printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Cutting Report</title>
          <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
          <style>
              body { font-family: 'Times New Roman', serif; margin:0; padding:15px; background:white; color:#000; }
              .report-paper { width:100%; max-width:100%; margin:auto; padding:15px; background:white; }
              .header-section { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #eee; padding-bottom:10px; margin-bottom:16px; }
              .company-name { font-size:20px; font-weight:bold; text-transform:uppercase; margin:0 0 4px 0; }
              .company-text { font-size:14px; margin:2px 0; display:flex; align-items:center; }
              .logo-container img { max-height:70px; max-width:150px; }
              .report-title { font-size:20px; text-align:center; margin:16px 0; }
              .meta-box { border:1px solid #000; padding:8px; font-size:13px; margin-bottom:16px; }
              .dep-table { width:100%; border-collapse:collapse; font-size:13px; margin-bottom:24px; }
              .dep-table th, .dep-table td { border:1px solid #000; padding:6px; vertical-align:middle; }
              .dep-table th { background:#e0e0e0; text-align:center; }
              .text-center { text-align:center; }
              .text-right { text-align:right; }
              .v-row { display: flex !important; flex-wrap: wrap !important; }
              .v-col-4 { flex: 0 0 33.3333% !important; max-width: 33.3333% !important; width: 33.3333% !important; box-sizing: border-box; }
              .v-col-4 div {  min-height: 60px; border-top: 1px solid #000; padding-top: 4px; }

              @media print {
              body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                .page-header { display:table-header-group; }
                .dep-table thead { display:table-header-group; }
              }
          </style>
          </head>
          <body>
          ${printContent}
          </body>
          </html>
      `);

      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => printWindow.print(), 500);
  }

onMounted(() => {
  fetchDetails(route.params.id);
});
</script>

<style scoped>
.full-height { min-height: 100vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 20px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 14px; }
.report-title { font-size: 20px; text-align: center; margin: 16px 0; }
.meta-box { border: 1px solid #000; padding: 8px; font-size: 13px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 6px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }



</style>
